// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"7b268644","710":"ab78b1bd"}[chunkId] + ".chunk.js";
};